import React from 'react';
import './styles.css'

class ErrorMessage extends React.Component {

    render() {
        const {errorMessage, type} = this.props;
        const icon = this.getIcon();

        return (
            <div>
                {errorMessage &&
                    <div className='errorMessageContainer'>
                        <p className='errorMessage'>{errorMessage}</p>
                        <img src={icon} />
                    </div>
                }
            </div>
        );
    }

    getIcon = () => {
        const {type} = this.props;
        if (type === 'warning') {
            return '/assets/warning_icon.png';
        }
        return '/assets/error_icon_1.png';
    };
}

export default ErrorMessage;


// WEBPACK FOOTER //
// ./src/components/ErrorMessage/index.js